import { MiButton } from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { IBidArea, IMaterialsResponse } from "@miplatform/types";
import { Divider, useTheme } from "@mui/material";
import { MaterialCard } from "../../../../../components/MaterialCard/MaterialCard";

export function MaterialResultCard({
  index,
  material,
  isSelected,
  handleSelectItem,
  checkedAreas,
  handleAddItemToOption,
}: MaterialResultCardProps) {
  const theme = useTheme();

  return (
    <>
      {index > 0 && <Divider sx={{ margin: theme.spacing(1, 0) }} />}
      <MaterialCard
        noCardStyle
        item={material}
        isSelected={isSelected}
        onClickCard={() => handleSelectItem(material)}
        rightAction={
          isSelected && (
            <MiButton
              title="Add to Area"
              variant={BUTTON_VARIANTS.CONTAINED}
              disabled={!checkedAreas.length}
              onClick={handleAddItemToOption}
            />
          )
        }
      />
    </>
  );
}

interface MaterialResultCardProps {
  index: number;
  material: IMaterialsResponse;
  isSelected: boolean;
  handleSelectItem: (material: IMaterialsResponse) => void;
  checkedAreas: IBidArea[];
  handleAddItemToOption: () => void;
}
